import { Fragment, useEffect, useState } from "react";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { SubFamilyContainer } from "./productListing";
import { isValidArray } from "../../Layout/Common/common";

export const AdditionalProducts = ({ params, view = "table" }) => {
  const [familyList, setFamilyList] = useState(null);
  useEffect(() => {
    if (params) {
      setFamilyList(params);
    } else {
      setFamilyList(null);
    }
  }, [params]);

  return (
    <Fragment>
      {isValidArray(familyList) &&
        [...familyList] // 👈 clone so you don’t mutate original state
          .sort((a, b) => {
            const orderA = Number(a?.sortOrder ?? 0);
            const orderB = Number(b?.sortOrder ?? 0);
            return orderA - orderB; // ascending
          })
          .map((item) => (
            <div className="col-lg-12 mt-40" key={item.familyId}>
              <SubFamilyContainer params={item} view={view} />
            </div>
          ))}
    </Fragment>
  );
};
